import { AuthorListPage } from '../../../components/Author/AuthorListPage';
import {
  DEFAULT_PAGE,
  DOMAIN_CODE,
} from '../../../components/Author/constants';
import { IGET_AUTHOR_LAYOUT } from '../../../components/Author/types';
import { getStaticPropsAuthorData } from '../../../components/Author/utils/authorListUtils';
import { staticPropsWrapper } from '../../../utils/static-pages/utils';

const AuthorsListsPage = ({ data }: IGET_AUTHOR_LAYOUT): JSX.Element => {
  return <AuthorListPage data={data} />;
};

export default AuthorsListsPage;

export const getStaticProps = staticPropsWrapper(__filename, () =>
  getStaticPropsAuthorData(DOMAIN_CODE, DEFAULT_PAGE)
);
